export const URL_API = "https://app.bikinilovers.it/api/v1/cashier";
export const BASE_URL = "https://app.bikinilovers.it";
